import React from "react";
import { StyledBadge } from "./styles";
import { oneOfType, arrayOf, node, oneOf } from "prop-types";
import colours from "assets/colours";

const Badge = ({ children, variant, ...rest }) => {
  const attrs = { variant, ...rest };
  return <StyledBadge {...attrs}>{children}</StyledBadge>;
};

export default Badge;

Badge.defaultProps = {
  variant: "",
};

Badge.propTypes = {
  variant: oneOf(["", ...Object.keys(colours)]),
  children: oneOfType([arrayOf(node), node]).isRequired,
};
